import { render } from "./nosotros.vue?vue&type=template&id=30b77848&scoped=true"
import script from "./nosotros.vue?vue&type=script&lang=js"
export * from "./nosotros.vue?vue&type=script&lang=js"

import "./nosotros.vue?vue&type=style&index=0&id=30b77848&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30b77848"]])

export default __exports__